import React from "react";
import Contact from "./Contact";
import Reference from "./Reference";

const ReferenceAndContact = (props) => {
  const {
    onAddContact,
    addContact,
    onAddReference,
    addReference,
    values,
    branchId,
    changeReferrerType,
  } = props;

  return (
    <div style={{ display: "flex", width: "100%", flexDirection: "column" }}>
      <Contact
        onAddContact={onAddContact}
        addContact={addContact}
        branchId={branchId}
      />
      <Reference
        onAddReference={onAddReference}
        addReference={addReference}
        values={values}
        branchId={branchId}
        changeReferrerType={changeReferrerType}
      />
    </div>
  );
};

export default ReferenceAndContact;
